import { Box, Divider, IconButton, keyframes, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../stateManagement/store";
import { useNavigate } from "react-router-dom";
import AuthService from "../../services/AuthService";
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import PeopleIcon from '@mui/icons-material/People';
import { removeSelectedOrganization, selectSelectedOrganization } from "../../stateManagement/selectedOrganizationSlice";
import { useDispatch } from "react-redux";
import { openClientsDialog } from "../../stateManagement/clientsDialogSlice";
import ClientListDialog from "../client/ClientListDialog";
import { openOrganizationTasksDialog } from "../../stateManagement/organizationTasksDialogSlice";
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { removeSelectedServiceProvider, selectSelectedServiceProvider } from "../../stateManagement/selectedServiceProviderSlice";
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import StoreIcon from '@mui/icons-material/Store';
import { openServiceProviderAvailabilitiesDialog } from "../../stateManagement/serviceProviderAvailabilitiesDialogSlice";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { removeTarget, selectTarget } from "../../stateManagement/targetSlice";
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { removeSelectedOrganizationForUser } from "../../stateManagement/selectedOrganizationForUserSlice";
import { removeSelectedServiceProviderForUser } from "../../stateManagement/selectedServiceProviderForUserSlice";
import { selectPublicUserMenu, setPublicUserMenu } from "../../stateManagement/publicUserMenuSlice";
import FavoriteIcon from '@mui/icons-material/Favorite';
import DateRangeIcon from '@mui/icons-material/DateRange';
import HomeIcon from '@mui/icons-material/Home';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import UserDetailDialog from "./UserDetailDialog";
import InfoComponent from "../../customComponents/InfoComponent";
import InfoToggleButton from "./InfoToggleButton";
import { openLoyaltyPointsDialog } from "../../stateManagement/loyaltyPointsDialogSlice";
import ReportIcon from '@mui/icons-material/Report';
import RemoveIcon from '@mui/icons-material/Remove';
import OrganizationTaskListDialog from "../organizationTask/OrganizationTaskListDialog";
import LoyaltyPointListDialog from "../loyaltyPoint/LoyaltyPointListDialog";
import ReportDialog from "../report/ReportDialog";
import PaidIcon from '@mui/icons-material/Paid';
import GettingPro from "../GettingPro";
import { openGettingProDialog } from "../../stateManagement/gettingProDialogSlice";
import ShareIcon from '@mui/icons-material/Share';

// Define blink animation
const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`;

const paidIcon = (<Box
    component="span"
    sx={{
        animation: `${blink} 1s infinite`,
        display: "inline-flex",
        alignItems: "center",
        ml: 1,
        color: "red"
    }}
>
    <PaidIcon />
</Box>)

const UserMenu: React.FC = () => {

    const proVersion = false;

    const dispatch = useDispatch<AppDispatch>();

    const target = useSelector(selectTarget);
    const publicUserMenu = useSelector(selectPublicUserMenu);
    const organization = useSelector(selectSelectedOrganization);
    const serviceProvider = useSelector(selectSelectedServiceProvider);

    const auth = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);


    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        AuthService.logout();
        navigate('/login');
    };

    const [userDetailDialogState, setUserDetailDialogState] = useState<{
        open: boolean;
    }>({ open: false });

    const handleOpenUserSetting = () => {
        setAnchorEl(null);
        setUserDetailDialogState({ open: true });
    };

    const handleCloseUserSetting = () => {
        setUserDetailDialogState({ open: false });
    };

    const handleOpenClients = () => {
        setAnchorEl(null);
        dispatch(openClientsDialog())
    };

    const handleOpenShareLink = () => {
        setAnchorEl(null);

    };

    const handleOpenServices = () => {
        setAnchorEl(null);
        dispatch(openOrganizationTasksDialog())
    };

    const handleOpenLoyaltyPoints = () => {
        setAnchorEl(null);
        dispatch(openLoyaltyPointsDialog())
    };

    const handleOpenGettingPro = () => {
        setAnchorEl(null);
        dispatch(openGettingProDialog())
    };

    const handleOpenServiceProviders = () => {
        setAnchorEl(null);
        dispatch(removeSelectedServiceProvider());

    };

    const handleOpenServiceOrganizations = () => {
        setAnchorEl(null);
        dispatch(removeSelectedOrganization());
        dispatch(removeSelectedServiceProvider());
    };

    const handleOpenAvailabilities = () => {
        setAnchorEl(null);
        dispatch(openServiceProviderAvailabilitiesDialog({
            organizationId: organization.organizationId ?? 0,
            serviceProviderId: serviceProvider.serviceProviderId ?? 0,
            serviceProviderName: serviceProvider.name ?? ''
        }))
    };

    const [reportOpen, setReportOpen] = useState<boolean>(false);

    const handleOpenReport = () => {
        setAnchorEl(null);
        setReportOpen(true);
    };

    const handleCloseReport = () => {
        setReportOpen(false);
    };

    return (
        <Box sx={{
            color: 'text.primary',
        }}>
            <InfoToggleButton />
            <IconButton sx={{ marginLeft: '5px' }} onClick={handleMenuOpen} style={{ cursor: 'pointer' }}>
                <MenuIcon />
            </IconButton>
            <Menu className="root-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                {/* <InfoComponent infoContent='View or update your profile details and password'>
                    <MenuItem onClick={handleOpenUserSetting}><AccountCircleIcon />{auth.token?.fullName}</MenuItem>
                </InfoComponent> */}
                {/* {target &&
                    <InfoComponent infoContent='Return to the main menu to choose between booking appointments or managing your places'>
                        <MenuItem onClick={() => { dispatch(removeTarget()); dispatch(removeSelectedOrganizationForUser()); dispatch(removeSelectedServiceProviderForUser()); setAnchorEl(null); }}><HomeIcon />Main menu</MenuItem>
                    </InfoComponent>
                } */}

                {/* {target === 'manageOrganizations' &&
                    <> */}
                {organization.organizationId &&

                    <>
                        {/* <Divider /> */}
                        <InfoComponent infoContent='Manage and select places (add, edit, or remove)'>
                            <MenuItem onClick={handleOpenServiceOrganizations}><StoreIcon />Places</MenuItem>
                        </InfoComponent>
                        <InfoComponent infoContent='Manage and select service providers (add, edit, or remove)'>
                            <MenuItem onClick={handleOpenServiceProviders}><EmojiEmotionsIcon />Service providers</MenuItem>
                        </InfoComponent>
                        <InfoComponent infoContent='Add or edit the list of services offered'>
                            <MenuItem onClick={handleOpenServices}><DesignServicesIcon />Services</MenuItem>
                        </InfoComponent>

                        <InfoComponent infoContent='View and manage your client list'>
                            <MenuItem onClick={handleOpenClients}><PeopleIcon />Clients</MenuItem>
                        </InfoComponent>
                    </>}
                {serviceProvider.serviceProviderId && <>
                    <InfoComponent infoContent='Set or update availability times for service providers'>
                        <MenuItem key={0} onClick={() => handleOpenAvailabilities()}>
                            <EventAvailableIcon />  Availabilities
                        </MenuItem>
                    </InfoComponent>
                </>}
                {organization.organizationId && <>
                    <InfoComponent infoContent='Generate and share a booking link with your customers.'>
                        <MenuItem onClick={() => { proVersion ? handleOpenShareLink() : handleOpenGettingPro() }}><ShareIcon />Share Booking Link{!proVersion && paidIcon}</MenuItem>
                    </InfoComponent>
                    <InfoComponent infoContent='Add or edit the list of Place Loyalty Rules'>
                        <MenuItem onClick={() => { proVersion ? handleOpenLoyaltyPoints() : handleOpenGettingPro() }}><LoyaltyIcon />Loyalty Rules{!proVersion && paidIcon} </MenuItem>
                    </InfoComponent>
                    <Divider />
                    <InfoComponent infoContent='View Application reports'>
                        <MenuItem onClick={() => { proVersion ? handleOpenReport() : handleOpenGettingPro() }}><ReportIcon />Reports{!proVersion && paidIcon}</MenuItem>
                    </InfoComponent>
                    <Divider />
                </>}
                {/* {target === 'bookAppointment' &&
                    <>
                        <Divider />
                        {publicUserMenu !== 'GetAppointment' &&
                            <InfoComponent infoContent='Search available places and service providers to book a new appointment'>
                                <MenuItem onClick={() => { dispatch(setPublicUserMenu('GetAppointment')); setAnchorEl(null); }}><InsertInvitationIcon />Get appointment</MenuItem>
                            </InfoComponent>
                        }
                        {publicUserMenu !== 'AppointmentList' &&
                            <InfoComponent infoContent='View your upcoming and past appointments'>
                                <MenuItem onClick={() => { dispatch(setPublicUserMenu('AppointmentList')); setAnchorEl(null); }}><DateRangeIcon />Your appointments</MenuItem>
                            </InfoComponent>
                        }
                        {publicUserMenu !== 'FavoriteOrganization' &&
                            <InfoComponent infoContent='Access your list of follower places'>
                                <MenuItem onClick={() => { dispatch(setPublicUserMenu('FavoriteOrganization')); setAnchorEl(null); }}><FavoriteIcon />Your follower places</MenuItem>
                            </InfoComponent>
                        }
                        <Divider />
                    </>
                } */}
                <InfoComponent infoContent='Sign out of your account'>
                    <MenuItem onClick={handleLogout}><LogoutIcon />Logout</MenuItem>
                </InfoComponent>
            </Menu>
            <ClientListDialog />
            <OrganizationTaskListDialog />
            <LoyaltyPointListDialog />
            <GettingPro />
            <ReportDialog open={reportOpen} close={handleCloseReport} />
            <UserDetailDialog state={userDetailDialogState} closeUserDialog={handleCloseUserSetting} />
        </Box>
    );
};

export default UserMenu;
